import {
  getUserInfo,
  userInfoType,
  getLogin,
  getLogout,
  getTT4BWebAccountInfo,
} from "@/api/request/login";
import store from "..";
import { accountSDK } from "@/api/apiConst/passport";
import Tea from "@dp/byted-tea-sdk-oversea";
import { getLoginVisitor } from "@/api/request/login";
import router from "@/router";
import { postStudentSubjectInfo } from "@/api/request/user";
import accountLogin from "@/utils/login";
export interface operateStateType {
  userInfo: userInfoType;
  innerWidth: number;
  contactUsVisible: boolean;
  /** 选择主体信息弹窗开关 */
  subjectDialog: boolean;
  /** 登录账户选择弹窗开关 */
  loginBeforeDialog: boolean;
  mobileDialog: boolean;
  source?: string;
  // 信息完善弹窗
  infoPerfectDialog: boolean;
  // 认证服务商报名升级弹窗
  visitorSignUpDialog: boolean;
  redirectInfo: {
    path: string;
    fullPath: string;
    name: string;
    query: any;
  };
  languageList: {
    label: string;
    value: string;
  }[];
  currentLanguage: string;
  learnCodeDialog: boolean;
  learnCodeFixedDialog: boolean;
  overallIcon: boolean;
  isGrowthIconFlag: boolean; //成长计划是否完成课程学习
  isGrowthIconFlagDialog: boolean; //成长计划继续学习弹窗开关
  benefitCourseFlagDialog: boolean; //福利课程弹窗开关
  benefitCourseFlagIconDialog: boolean; //福利课程icon弹窗开关
  marketDataId: string; // 顶部市场选择数据id
}
function getTTAMLogin(type: "normal" | "employee") {
  return new Promise((resolve, reject) => {
    accountSDK.login
      .checkLogin({})
      .then(() => {
        getTT4BWebAccountInfo({
          visitor:
            localStorage.getItem(process.env.VUE_APP_VISITOR) || undefined,
        })
          .then((res) => {
            if (res.data.token) {
              localStorage.setItem(
                process.env.VUE_APP_TOKEN_KEY,
                res.data.token
              );
              localStorage.removeItem(process.env.VUE_APP_VISITOR);
              store.dispatch("GetInfo");
              resolve(res.data);
            } else {
              let url = `${
                process.env.VUE_APP_TT4B_URL
              }?redirect=${encodeURIComponent(
                `${process.env.VUE_APP_TT4B_ACADEMY_URL}auth/callback?redirectUrl=${store.state.user.redirectInfo.fullPath}`
              )}&_source_=bussiness`;
              if (type === "employee") {
                url += "&user_type=employee";
              }
              window.location.href = url;
              reject(res.data);
            }
          })
          .catch((err) => {
            let url = `${
              process.env.VUE_APP_TT4B_URL
            }?redirect=${encodeURIComponent(
              `${process.env.VUE_APP_TT4B_ACADEMY_URL}auth/callback?redirectUrl=${store.state.user.redirectInfo.fullPath}`
            )}&_source_=bussiness`;
            if (type === "employee") {
              url += "&user_type=employee";
            }
            window.location.href = url;
            reject(err);
          });
      })
      .catch(() => {
        let url = `${
          process.env.VUE_APP_TT4B_URL
        }?redirect=${encodeURIComponent(
          `${process.env.VUE_APP_TT4B_ACADEMY_URL}auth/callback?redirectUrl=${store.state.user.redirectInfo.fullPath}`
        )}&_source_=bussiness`;
        if (type === "employee") {
          url += "&user_type=employee";
        }
        window.location.href = url;
      });
  });
}
export const user = {
  state: {
    userInfo: {},
    innerWidth: document.body.clientWidth,
    contactUsVisible: false,
    subjectDialog: false,
    loginBeforeDialog: false,
    mobileDialog: false,
    infoPerfectDialog: false,
    visitorSignUpDialog: false,
    source: "",
    redirectInfo: {},
    languageList: [
      {
        label: "简体中文",
        value: "zh-CN",
      },
      {
        label: "English",
        value: "en-US",
      },
      {
        label: "日本語",
        value: "ja-JP",
      },
      {
        label: "한국어",
        value: "ko-KR",
      },
    ],
    currentLanguage: "",
    learnCodeDialog: false,
    learnCodeFixedDialog: false,
    overallIcon: true,
    isGrowthIconFlag: false,
    isGrowthIconFlagDialog: false,
    benefitCourseFlagDialog: false,
    benefitCourseFlagIconDialog: false,
    marketDataId: "",
  } as operateStateType,
  getters: {
    isLogin: (state: any) => {
      return state.userInfo.name;
    },
    isVisitor: (state: any) => {
      console.log("获取游客信息");
      return state.userInfo.type === "0";
    },
    getUser: (state: operateStateType) => {
      return state.userInfo;
    },
  },
  mutations: {
    SET_MARKETDATAID: (state: any, data: string) => {
      state.marketDataId = data;
    },
    SET_OVERALLICON: (state: any, data: boolean) => {
      state.overallIcon = data;
    },
    SET_LEARNCODEDIALOG: (state: any, data: boolean) => {
      state.learnCodeDialog = data;
    },
    SET_LEARNCODEFIXEDDIALOG: (state: any, data: boolean) => {
      state.learnCodeFixedDialog = data;
    },
    SET_ISGROWTHICONFLAG: (state: any, data: boolean) => {
      state.isGrowthIconFlag = data;
    },
    SET_ISGROWTHICONFLAGDIALOG: (state: any, data: boolean) => {
      state.isGrowthIconFlagDialog = data;
    },
    SET_BENEFITCOURSEFLAGDIALOG: (state: any, data: boolean) => {
      state.benefitCourseFlagDialog = data;
    },
    SET_BENEFITCOURSEFLAGICONDIALOG: (state: any, data: boolean) => {
      state.benefitCourseFlagIconDialog = data;
    },
    SET_CURRENTLANGUAGE: (state: any, language: string) => {
      state.currentLanguage = language;
    },
    SET_SOURCE: (state: any, source: string) => {
      state.source = source;
    },
    SET_VISITORS_SIGNUP_DIALOG: (state: any, status: boolean) => {
      state.visitorSignUpDialog = status;
    },
    SET_INFO_PERFECT_DIALOG: (state: any, status: boolean) => {
      state.infoPerfectDialog = status;
    },
    SET_REDIRECT_INFO: (
      state: any,
      status: operateStateType["redirectInfo"]
    ) => {
      state.redirectInfo = status;
    },
    SET_MOBILE_DIALOG: (state: any, status: boolean) => {
      state.mobileDialog = status;
    },
    SET_LOGIN_BEFORE: (state: any, status: boolean) => {
      state.loginBeforeDialog = status;
    },
    SET_SUBJECT_DIALOG: (state: any, status: boolean) => {
      state.subjectDialog = status;
    },
    SET_USERINFO: (state: any, userInfo: userInfoType) => {
      state.userInfo = userInfo;
    },
    SET_USERINFO_TYPE: (state: any, type: string) => {
      state.userInfo.type = type;
    },
    SET_USERINFO_PLAY: (state: any, status: string) => {
      state.userInfo.playStatus = status;
    },
    SET_CONTACTUSVISIBLE: (state: any, data: boolean) => {
      state.contactUsVisible = data;
    },
  },
  actions: {
    Logout({ commit }: any) {
      // 退出登录||登录失效
      return new Promise((resolve, reject) => {
        getLogout()
          .then((res) => {
            let visitor = "";
            if (localStorage.getItem(process.env.VUE_APP_VISITOR)) {
              visitor = localStorage.getItem(
                process.env.VUE_APP_VISITOR
              ) as string;
            }
            let language = "";
            if (localStorage.getItem(process.env.VUE_APP_LANGURAGE)) {
              language = localStorage.getItem(
                process.env.VUE_APP_LANGURAGE
              ) as string;
            }
            localStorage.clear();
            sessionStorage.clear();
            localStorage.removeItem(process.env.VUE_APP_TOKEN_KEY);
            commit("SET_USERINFO", {});
            if (visitor)
              localStorage.setItem(process.env.VUE_APP_VISITOR, visitor);
            if (language)
              localStorage.setItem(process.env.VUE_APP_LANGURAGE, language);
            if (process.env.NODE_ENV !== "development") {
              if (
                window.location.origin.indexOf(
                  "tiktokforbusiness-learning-center.com"
                ) > -1
              ) {
                // 国内版本
                accountLogin.login.logout({ next: "/", need_redirect: 0 });
              } else {
                // 国外版本
                accountSDK.login.logout({ next: "/", need_redirect: 0 });
              }
            }
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    /** TT4B 回调登陆 */
    TT4BLogin({ commit }: any) {
      return new Promise((resolve, reject) => {
        accountSDK.login
          .checkLogin({})
          .then(() => {
            getTT4BWebAccountInfo({
              visitor:
                localStorage.getItem(process.env.VUE_APP_VISITOR) || undefined,
            })
              .then((res) => {
                // console.log("TT4BLogin 1");
                if (res.data.token) {
                  // console.log("TT4BLogin set token", res.data.token);
                  localStorage.setItem(
                    process.env.VUE_APP_TOKEN_KEY,
                    res.data.token
                  );
                  localStorage.removeItem(process.env.VUE_APP_VISITOR);
                  resolve(res.data);
                } else {
                  // console.log("TT4BLogin 2 no token");
                  reject(res.data);
                }
              })
              .catch((err) => {
                // console.log(
                //   "TT4BLogin 3 caught err getTT4BWebAccountInfo",
                //   err
                // );
                reject(err);
              });
          })
          .catch((err: any) => {
            // console.log("TT4BLogin 3 caught err accoundsdk", err);
            reject(err);
          });
      });
    },
    // 登录前校验
    LoginBefore() {
      return new Promise((resolve) => {
        const path = encodeURIComponent(
          window.location.pathname + window.location.search
        );
        if (window.matchMedia("(max-width: 767px)").matches) {
          router.replace({
            path: "/mobile/loginBefore",
          });
        } else {
          router.replace({
            path: "/operate/loginBefore",
          });
        }
        resolve(true);
      });
    },
    /** 登录 */
    Login({ commit }: any, data: { ident: string; type?: string }) {
      return new Promise((resolve, reject) => {
        if (data?.ident && process.env.NODE_ENV === "development") {
          // uid登录
          console.log("登录账户", data.ident);
          getLogin({
            username: data.ident,
            visitor:
              localStorage.getItem(process.env.VUE_APP_VISITOR) || undefined,
          })
            .then((res) => {
              if (res.data.token) {
                localStorage.setItem(
                  process.env.VUE_APP_TOKEN_KEY,
                  res.data.token
                );
                localStorage.removeItem(process.env.VUE_APP_VISITOR);
                store.dispatch("GetInfo").then((res) => {
                  resolve(res.data);
                });
              } else {
                reject(res.data);
              }
            })
            .catch((err) => {
              reject(err);
            });
        } else if (data?.type === "employee") {
          // 内部员工登录
            if (
              window.location.origin.indexOf(
                "tiktokforbusiness-learning-center.com"
              ) > -1 ||
              process.env.NODE_ENV === "development"
            ) {
              // 国内版本
              window.location.href =
                `https://accounts.feishu.cn/open-apis/authen/v1/authorize?client_id=cli_a96d94c3aea29bc4&response_type=code&redirect_uri=${window.location.origin}/auth`;
            } else {
              // 正常登录
              getTTAMLogin(data?.type)
                .then((res) => {
                  resolve(res);
                })
                .catch((err) => {
                  reject(err);
                });
            }
        } else if (data?.type === "visitor") {
          // 游客登录
          getLoginVisitor().then((res) => {
            if (res.data.token) {
              localStorage.setItem(
                process.env.VUE_APP_TOKEN_KEY,
                res.data.token
              );
              localStorage.setItem(
                process.env.VUE_APP_VISITOR,
                res.data.username
              );
              store.dispatch("GetInfo").then((res) => {
                resolve(res.data);
              });
            }
          });
        } else {
          console.log("登录账户", data.ident, process.env.NODE_ENV);
          if (
            window.location.origin.indexOf(
              "tiktokforbusiness-learning-center.com"
            ) > -1 ||
            process.env.NODE_ENV === "development"
          ) {
            // 国内版本
            // getTTAMLogin("normal")
            router.replace({
              path: "/operate/login",
            });
          } else {
            // 正常登录
            getTTAMLogin("normal")
              .then((res) => {
                resolve(res);
              })
              .catch((err) => {
                reject(err);
              });
          }
        }
      });
    },
    /** 获取用户信息 */
    GetInfo({ commit }: any) {
      // console.log("请求用户信息");
      return new Promise((resolve, reject) => {
        getUserInfo()
          .then((res) => {
            if (res.data) {
              if (!res.data.icon) {
                res.data.iconName = res.data.name[0];
              }
              localStorage.setItem("tt4b_academy_uid", res.data.uid);
              localStorage.setItem("tt4b_academy_username", res.data.name);
              localStorage.setItem("tt4b_academy_type", res.data.type);
              Tea.config({
                user_id: res.data.uid,
                user_type: parseInt(res.data.type),
                user_is_login: 1,
                evtParams: {
                  tt4b_uid: res.data.uid,
                  tt4b_username: res.data.name,
                  tt4b_user_type: res.data.type,
                },
              });
              commit("SET_USERINFO", {
                ...res.data,
                type: res.data.type === "3" ? "1" : res.data.type,
              });

              if (
                (store.state.user.userInfo.type === "4" ||
                  store.state.user.userInfo.type === "6" ||
                  store.state.user.userInfo.type === "7") &&
                localStorage.getItem(
                  process.env.VUE_APP_LANGURAGE as string
                ) !== "en-US" &&
                sessionStorage.getItem("once_language") !== "1"
              ) {
                localStorage.setItem(
                  process.env.VUE_APP_LANGURAGE as string,
                  "en-US"
                );

                window.location.reload();
              }
              if (
                store.state.user.userInfo.type !== "4" &&
                store.state.user.userInfo.type !== "6" &&
                store.state.user.userInfo.type !== "7" &&
                localStorage.getItem(
                  process.env.VUE_APP_LANGURAGE as string
                ) !== "zh-CN" &&
                sessionStorage.getItem("once_language") !== "1"
              ) {
                localStorage.setItem(
                  process.env.VUE_APP_LANGURAGE as string,
                  "zh-CN"
                );
                window.location.reload();
              }
              sessionStorage.setItem("once_language", "1");

              // 获取用户信息后 判断是否需要完善信息
              if (
                (store.state.user.userInfo.type === "1" ||
                  store.state.user.userInfo.type === "2" ||
                  store.state.user.userInfo.type === "4" ||
                  store.state.user.userInfo.type === "7") &&
                !store.state.user.userInfo.useType
                // &&
                // store.state.user.userInfo.num === 0
              ) {
                // 后台类型为品牌方或服务商 且没有用户输入类型 &没有待审核信息
                postStudentSubjectInfo().then((res) => {
                  if (!res.data) {
                    commit("SET_INFO_PERFECT_DIALOG", true);
                  }

                  if (res.data) {
                    if (res.data.status == 2) {
                      commit("SET_INFO_PERFECT_DIALOG", true);
                    }
                  }
                });
              }
            }
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
